import type * as React from 'react';

import { redirectTo } from '@xing-com/crate-core-router';
import type { RoutesMap } from '@xing-com/crate-xinglet';

import { RouteHandlerCity } from './route-handler-city';
import { RouteHandlerUsername } from './route-handler-username';

const NotFound: React.FC = () => {
  return redirectTo('/people');
};

export const routes: RoutesMap = {
  '/people/cities/:country/:city/:citySlugOrLetter': RouteHandlerCity,
  '/people/:slugOrLetter': RouteHandlerUsername,
  '/people/*notfound': NotFound,
};
